module.exports = __webpack_public_path__ + "static/img/11.d0ed5bce.jpg";